export interface LanguageCatalogEntry {
  name: string;
  iso3: string;
  aliases: string[];
}

const ENTRIES: LanguageCatalogEntry[] = [
  { name: "English", iso3: "eng", aliases: ["eng", "en", "english", "enus", "engus"] },
  { name: "English (US)", iso3: "eng", aliases: ["en-us", "enus", "english us", "american english"] },
  { name: "English (UK)", iso3: "eng", aliases: ["en-gb", "engb", "english uk", "british english"] },
  { name: "Swedish", iso3: "swe", aliases: ["sv", "swe", "swedish", "svenska"] },
  { name: "Norwegian", iso3: "nor", aliases: ["no", "nor", "norwegian"] },
  { name: "Norwegian Bokmal", iso3: "nob", aliases: ["nb", "nob", "nbo", "bokmal", "norwegian bokmal"] },
  { name: "Norwegian Nynorsk", iso3: "nno", aliases: ["nn", "nno", "nynorsk", "norwegian nynorsk"] },
  { name: "Danish", iso3: "dan", aliases: ["da", "dan", "danish"] },
  { name: "Finnish", iso3: "fin", aliases: ["fi", "fin", "finnish", "suomi"] },
  { name: "German", iso3: "deu", aliases: ["de", "deu", "ger", "german"] },
  { name: "German (Austria)", iso3: "deu", aliases: ["de-at", "german austria"] },
  { name: "German (Switzerland)", iso3: "deu", aliases: ["de-ch", "german switzerland"] },
  { name: "French", iso3: "fra", aliases: ["fr", "fra", "fre", "french"] },
  { name: "French (Canada)", iso3: "fra", aliases: ["fr-ca", "french canada"] },
  { name: "French (Belgium)", iso3: "fra", aliases: ["fr-be", "french belgium"] },
  { name: "French (Switzerland)", iso3: "fra", aliases: ["fr-ch", "french switzerland"] },
  { name: "Spanish", iso3: "spa", aliases: ["es", "spa", "esp", "spanish"] },
  { name: "Spanish (Mexico)", iso3: "spa", aliases: ["es-mx", "spanish mexico"] },
  { name: "Spanish (Argentina)", iso3: "spa", aliases: ["es-ar", "spanish argentina"] },
  { name: "Spanish (US)", iso3: "spa", aliases: ["es-us", "spanish us"] },
  { name: "Italian", iso3: "ita", aliases: ["it", "ita", "italian"] },
  { name: "Dutch", iso3: "nld", aliases: ["nl", "nld", "dut", "dutch"] },
  { name: "Dutch (Belgium)", iso3: "nld", aliases: ["nl-be", "dutch belgium", "flemish"] },
  { name: "Polish", iso3: "pol", aliases: ["pl", "pol", "polish"] },
  { name: "Portuguese", iso3: "por", aliases: ["pt", "por", "portuguese"] },
  { name: "Portuguese (Brazil)", iso3: "por", aliases: ["pt-br", "portuguese brazil"] },
  { name: "Portuguese (Portugal)", iso3: "por", aliases: ["pt-pt", "portuguese portugal"] },
  { name: "Czech", iso3: "ces", aliases: ["cs", "ces", "cze", "czech"] },
  { name: "Romanian", iso3: "ron", aliases: ["ro", "ron", "rum", "romanian"] },
  { name: "Slovak", iso3: "slk", aliases: ["sk", "slk", "slo", "slovak"] },
  { name: "Slovenian", iso3: "slv", aliases: ["sl", "slv", "slovenian"] },
  { name: "Croatian", iso3: "hrv", aliases: ["hr", "hrv", "croatian"] },
  { name: "Hungarian", iso3: "hun", aliases: ["hu", "hun", "hungarian"] },
  { name: "Estonian", iso3: "est", aliases: ["et", "est", "estonian"] },
  { name: "Latvian", iso3: "lav", aliases: ["lv", "lav", "latvian"] },
  { name: "Lithuanian", iso3: "lit", aliases: ["lt", "lit", "lithuanian"] },
  { name: "Greek", iso3: "ell", aliases: ["el", "ell", "gre", "greek"] },
  { name: "Turkish", iso3: "tur", aliases: ["tr", "tur", "turkish"] },
  { name: "Ukrainian", iso3: "ukr", aliases: ["uk", "ukr", "ukrainian"] },
  { name: "Russian", iso3: "rus", aliases: ["ru", "rus", "russian"] },
  { name: "Bulgarian", iso3: "bul", aliases: ["bg", "bul", "bulgarian"] },
  { name: "Serbian", iso3: "srp", aliases: ["sr", "srp", "serbian"] },
  { name: "Catalan", iso3: "cat", aliases: ["ca", "cat", "catalan"] },
  { name: "Basque", iso3: "eus", aliases: ["eu", "eus", "baq", "basque"] },
  { name: "Galician", iso3: "glg", aliases: ["gl", "glg", "galician"] },
  { name: "Icelandic", iso3: "isl", aliases: ["is", "isl", "ice", "icelandic"] },
  { name: "Maltese", iso3: "mlt", aliases: ["mt", "mlt", "maltese"] },
  { name: "Arabic", iso3: "ara", aliases: ["ar", "ara", "arb", "arabic"] },
  { name: "Hebrew", iso3: "heb", aliases: ["he", "heb", "hebrew"] },
  { name: "Hindi", iso3: "hin", aliases: ["hi", "hin", "hindi"] },
  { name: "Thai", iso3: "tha", aliases: ["th", "tha", "thai"] },
  { name: "Vietnamese", iso3: "vie", aliases: ["vi", "vie", "vietnamese"] },
  { name: "Japanese", iso3: "jpn", aliases: ["ja", "jpn", "japanese"] },
  { name: "Korean", iso3: "kor", aliases: ["ko", "kor", "korean"] },
  { name: "Chinese", iso3: "zho", aliases: ["zh", "zho", "chi", "chinese"] },
  { name: "Chinese (Simplified)", iso3: "zho", aliases: ["zh-cn", "chinese simplified"] },
  { name: "Chinese (Traditional)", iso3: "zho", aliases: ["zh-tw", "chinese traditional"] },
  { name: "Indonesian", iso3: "ind", aliases: ["id", "ind", "indonesian"] },
  { name: "Malay", iso3: "msa", aliases: ["ms", "msa", "may", "malay"] },
  { name: "Filipino", iso3: "fil", aliases: ["fil", "filipino", "tagalog"] },
  { name: "Irish", iso3: "gle", aliases: ["ga", "gle", "irish"] },
  { name: "Welsh", iso3: "cym", aliases: ["cy", "cym", "wel", "welsh"] },
  { name: "Afrikaans", iso3: "afr", aliases: ["af", "afr", "afrikaans"] },
  { name: "Albanian", iso3: "sqi", aliases: ["sq", "sqi", "alb", "albanian"] },
  { name: "Bosnian", iso3: "bos", aliases: ["bs", "bos", "bosnian"] },
  { name: "Macedonian", iso3: "mkd", aliases: ["mk", "mkd", "mac", "macedonian"] },
  { name: "Georgian", iso3: "kat", aliases: ["ka", "kat", "geo", "georgian"] },
  { name: "Armenian", iso3: "hye", aliases: ["hy", "hye", "arm", "armenian"] },
  { name: "Persian", iso3: "fas", aliases: ["fa", "fas", "per", "persian", "farsi"] },
  { name: "Urdu", iso3: "urd", aliases: ["ur", "urd", "urdu"] },
  { name: "Bengali", iso3: "ben", aliases: ["bn", "ben", "bengali"] },
  { name: "Tamil", iso3: "tam", aliases: ["ta", "tam", "tamil"] },
  { name: "Telugu", iso3: "tel", aliases: ["te", "tel", "telugu"] },
  { name: "Marathi", iso3: "mar", aliases: ["mr", "mar", "marathi"] },
  { name: "Gujarati", iso3: "guj", aliases: ["gu", "guj", "gujarati"] },
  { name: "Punjabi", iso3: "pan", aliases: ["pa", "pan", "punjabi"] },
  { name: "Swahili", iso3: "swa", aliases: ["sw", "swa", "swahili"] },
  { name: "Zulu", iso3: "zul", aliases: ["zu", "zul", "zulu"] },
  { name: "Xhosa", iso3: "xho", aliases: ["xh", "xho", "xhosa"] },
  { name: "Amharic", iso3: "amh", aliases: ["am", "amh", "amharic"] },
  { name: "Somali", iso3: "som", aliases: ["so", "som", "somali"] },
  { name: "Kurdish", iso3: "kur", aliases: ["ku", "kur", "kurdish"] },
  { name: "Luxembourgish", iso3: "ltz", aliases: ["lb", "ltz", "luxembourgish"] },
  { name: "Belarusian", iso3: "bel", aliases: ["be", "bel", "belarusian"] },
  { name: "Azerbaijani", iso3: "aze", aliases: ["az", "aze", "azerbaijani"] },
  { name: "Kazakh", iso3: "kaz", aliases: ["kk", "kaz", "kazakh"] },
  { name: "Uzbek", iso3: "uzb", aliases: ["uz", "uzb", "uzbek"] },
  { name: "Mongolian", iso3: "mon", aliases: ["mn", "mon", "mongolian"] },
  { name: "Nepali", iso3: "nep", aliases: ["ne", "nep", "nepali"] },
  { name: "Sinhala", iso3: "sin", aliases: ["si", "sin", "sinhala"] },
  { name: "Lao", iso3: "lao", aliases: ["lo", "lao"] },
  { name: "Khmer", iso3: "khm", aliases: ["km", "khm", "khmer"] },
  { name: "Burmese", iso3: "mya", aliases: ["my", "mya", "bur", "burmese"] },
];

function keyOf(value: string): string {
  return value.trim().toLowerCase().replace(/[^a-z0-9]+/g, "");
}

const ALIAS_TO_ENTRY = new Map<string, LanguageCatalogEntry>();
for (const entry of ENTRIES) {
  ALIAS_TO_ENTRY.set(keyOf(entry.name), entry);
  ALIAS_TO_ENTRY.set(keyOf(entry.iso3), entry);
  for (const alias of entry.aliases) {
    ALIAS_TO_ENTRY.set(keyOf(alias), entry);
  }
}

const ISO2_TO_ISO3: Record<string, string> = {
  en: "eng", sv: "swe", no: "nor", nb: "nob", da: "dan", fi: "fin", de: "deu", fr: "fra", es: "spa", it: "ita", nl: "nld", pl: "pol",
  pt: "por", cs: "ces", ro: "ron", sk: "slk", sl: "slv", hr: "hrv", hu: "hun", et: "est", lv: "lav", lt: "lit", el: "ell",
  tr: "tur", uk: "ukr", ru: "rus", bg: "bul", sr: "srp", ca: "cat", eu: "eus", gl: "glg", is: "isl", mt: "mlt", ar: "ara",
  he: "heb", hi: "hin", th: "tha", vi: "vie", ja: "jpn", ko: "kor", zh: "zho", id: "ind", ms: "msa", ga: "gle", cy: "cym",
  af: "afr", sq: "sqi", bs: "bos", mk: "mkd", ka: "kat", hy: "hye", fa: "fas", ur: "urd", bn: "ben", ta: "tam", te: "tel",
  mr: "mar", gu: "guj", pa: "pan", sw: "swa", zu: "zul", xh: "xho", am: "amh", so: "som", ku: "kur", lb: "ltz", be: "bel",
  az: "aze", kk: "kaz", uz: "uzb", mn: "mon", ne: "nep", si: "sin", lo: "lao", km: "khm", my: "mya",
};

export function normalizeLanguageName(value: string): string {
  const raw = value.trim();
  if (!raw) return "";
  const entry = ALIAS_TO_ENTRY.get(keyOf(raw));
  if (entry) return entry.name;
  return raw.length >= 2 ? raw : "";
}

export function getIso3Code(value: string): string {
  const raw = value.trim();
  if (!raw) return "";
  const entry = ALIAS_TO_ENTRY.get(keyOf(raw));
  if (entry) return entry.iso3;
  const low = raw.toLowerCase();
  if (/^[a-z]{3}$/.test(low)) return low;
  if (/^[a-z]{2}$/.test(low)) return ISO2_TO_ISO3[low] ?? "";
  return "";
}

export function isCatalogLanguage(value: string): boolean {
  const raw = value.trim();
  if (!raw) return false;
  return ALIAS_TO_ENTRY.has(keyOf(raw));
}

export function isReasonableLanguageValue(value: string): boolean {
  const raw = value.trim();
  if (raw.length < 2) return false;
  if (/^[a-z]$/i.test(raw)) return false;
  return true;
}

export function formatLanguageWithIso3(value: string): string {
  const name = normalizeLanguageName(value) || value.trim();
  const iso3 = getIso3Code(name);
  return `${name} (${(iso3 || "???").toUpperCase()})`;
}

export function getLanguageDisplayParts(value: string): { name: string; iso3: string } {
  const name = normalizeLanguageName(value) || value.trim();
  return {
    name,
    iso3: getIso3Code(name),
  };
}

export function getDefaultLanguageNames(): string[] {
  return ENTRIES.map((e) => e.name);
}
